export function executiveBoardPositionToField({ id }, field = 'title') {
  return `executive_board_position.${id}.${field}`;
}
